import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../api/client";
import { NewsListItem } from "./types";
import cls from "./NewsList.module.scss";

const NewsList: React.FC = () => {
    console.log('090++')
    const [items, setItems] = useState<NewsListItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState<string | null>(null);
    const nav = useNavigate();

    const load = async () => {
        setLoading(true); setErr(null);
        try {
            const data = await api.get<NewsListItem[]>("/api/news");
            setItems(data || []);
        } catch (e: any) {
            setErr(e?.message || "Ошибка загрузки");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, []);

    const onDelete = async (id: number) => {
        if (!window.confirm("Удалить новость?")) return;
        try {
            await api.delete(`/api/news/${id}`);
            setItems(prev => prev.filter(i => i.id !== id));
        } catch (e: any) {
            alert(e?.message || "Не удалось удалить");
        }
    };

    return (
        <div className={cls.card}>
            <div className={cls.header}>
                <h2 style={{ margin:0 }}>Новости</h2>
                <Link className={cls.btn} to="/news/new">+ Создать</Link>
            </div>

            {loading ? "Загрузка…" : err ? <div style={{ color: "crimson" }}>{err}</div> : (
                <table className={cls.table}>
                    <thead>
                    <tr>
                        <th>ID</th><th>Заголовок</th><th>Дата</th><th>Просмотр.</th><th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {items.map(n => (
                        <tr key={n.id}>
                            <td>{n.id}</td>
                            <td>{n.title}</td>
                            <td>{n.date}</td>
                            <td><span className={cls.badge}>{n.viewed ? "Есть" : "Нет"}</span></td>
                            <td style={{ textAlign:"right" }}>
                                <button className={`${cls.btn} ${cls.ghost}`} onClick={() => nav(`/news/${n.id}`)} style={{ marginRight: 8 }}>
                                    Редактировать
                                </button>
                                <button className={`${cls.btn} ${cls.red}`} onClick={() => onDelete(n.id)}>
                                    Удалить
                                </button>
                            </td>
                        </tr>
                    ))}
                    {items.length === 0 && (
                        <tr><td colSpan={5} style={{ opacity:.7, padding:12 }}>Пока нет новостей</td></tr>
                    )}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default NewsList;
